<template>
  <VEmojiPicker @select="selectEmoji" v-show="show" @changeCategory="handleChangeCategory" :emojisByRow="8" />
</template>

<script>
export default {
  props: ['show'],
  mounted () {
  },
  data () {
    return {
    }
  },
  methods: {
    handleChangeCategory () {
      this.$emit('change-category')
    },
    selectEmoji ({data}) {
      this.$emit('select', data)
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Emoji.vue